import { Tracker } from '../store/tracking/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { bulkUpdate, bulkUpdateGtkmData } from '../store/signup-data/action-creators';
import { getDomainFromEmail } from '../utils/getDomainFromEmail';
import { LOG } from '../http-complete-verification/handleCompleteVerificationError';
import { getSentryExtra } from '../error/getSentryExtra';
import { getCompanySizeOptionFromEmployeesRange } from '../company-info/companySize';
export const handleGTKMCompanyInfoSuccess = ({
  domain,
  name,
  industries = [],
  employeesRange,
  isFreeEmailDomain
}, dispatch) => {
  var _industries$;
  dispatch(Tracker.signupInteraction('gtkm-company-info-prefill-success'));
  dispatch(Tracker.signupInteraction('gtkm-company-info-is-freemail', {
    currentValue: isFreeEmailDomain
  }));
  const gtkmData = {
    [Data.CompanySize]: getCompanySizeOptionFromEmployeesRange(employeesRange) || '',
    [Data.CompanyName]: name || '',
    [Data.Industry]: (industries === null || industries === void 0 || (_industries$ = industries[0]) === null || _industries$ === void 0 ? void 0 : _industries$.name) || '',
    [Data.CompanyDomain]: domain || ''
  };
  dispatch(bulkUpdateGtkmData(gtkmData));
  dispatch(bulkUpdate(gtkmData));
};
export const handleGTKMCompanyInfoError = (error, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction(`gtkm-industry-prefill-${error.status}`));
  dispatch(Tracker.signupInteraction(`gtkm-company-info-prefill-error-${error.status}`));
  const email = getSignupDataValue(state, Data.Email);
  const domainFromEmail = getDomainFromEmail(email);
  LOG.error('GTKM Company Information Request Failed', {
    extra: Object.assign({}, getSentryExtra(error), {
      domainFromEmail
    })
  });
};